import DynamicFormSettingsResourceModel from '../../generated/types/model/resource/DynamicFormSettingsResourceModel';

export default class DynamicFormSettingsResourceViewModel extends DynamicFormSettingsResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
